import { styled } from '@mui/material/styles';

const PREFIX = 'withRequired';

export const classes = {
  root: `${PREFIX}-root`,
  required: `${PREFIX}-required`,
  value: `${PREFIX}-value`,
};

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    width: '100%',
    height: '100%',
  },

  [`& .${classes.required}`]: {
    display: 'flex',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    alignContent: 'center',
  },

  [`& .${classes.value}`]: {
    display: 'flex',
    flexGrow: 1,
    alignContent: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));